import initMilestonesShow from '~/pages/milestones/shared/init_milestones_show';
import milestones from '~/pages/milestones/shared';

document.addEventListener('DOMContentLoaded', () => {
  initMilestonesShow();
  milestones();
});
